export default {

    store: null,

    setStore(store) {
        this.store = store;
    },

    handle(event) {

        console.log('Received event: ' + event.name);

        // Desctructure event object
        const {name, data} = event;

        if (typeof this[name] === "function") {
            this[name](data);
        }
    },

    orderPlaced() {

        setTimeout(() => {

			console.log('Order placed event received');

            this.store.dispatch('checkout/reset');
            this.store.dispatch('cart/reset');
            sessionStorage.clear();

			// If this window is on the checkout page and this window is NOT the one sending the order, redirect home
            if (window.location.href.includes('checkout') && !this.store.state.checkout.sending_order) {
                window.location.href = route('home'); // redirect it home
            }
        }, 3000);

    },

    showModal(data) {

        this.store.dispatch('central/showModal', JSON.parse(data));

    }

}


